module.exports = __webpack_public_path__ + "media/pyro-p.32b3afa8.mp4";